/**
 * Pluralize a word based on the count.
 * @param count - The count of the word.
 * @param word - The word to pluralize.
 * @param pluralWord - The plural word to use if the count is not 1.
 * @returns The pluralized word.
 */
export const pluralize = (count: number, word: string, pluralWord?: string) => {
  return count === 1 ? word : pluralWord || `${word}s`;
};

/**
 * Formats name in "Last, First" format when both names are available,
 * otherwise returns whichever name is available.
 * @param firstName - The first name.
 * @param lastName - The last name.
 * @returns The name in "Last, First" format.
 */
export const formatNameReversed = (firstName?: string | null, lastName?: string | null): string => {
  return [lastName, firstName].filter(Boolean).join(', ');
};

/**
 * Converts name from "Last, First" format to "First Last" format.
 * Returns the original name if no comma is present.
 * @param name - The name to reverse.
 * @returns The name in "First Last" format.
 */
export const reverseNameFormat = (name: string): string => {
  if (!name.includes(',')) {
    return name;
  }
  const [last, first] = name.split(',').map((s) => s.trim());
  return `${first} ${last}`;
};
